import type { SVGProps } from 'react';
const SvgIconDisclosureDown = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.192 5.122a.743.743 0 0 1 1.05-.052L8 9.13l4.758-4.06a.743.743 0 0 1 .998 1.102L8.499 10.93a.743.743 0 0 1-.998 0L2.245 6.172a.743.743 0 0 1-.053-1.05"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconDisclosureDown;
